define('models/pixelPlacementReport',["T1", "T1Model"], function (T1, T1Model) {
  T1.Models.PixelPlacement = T1Model.extend({});
  return T1.Models.PixelPlacement;
});
